"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _CardStyles = require("./CardStyles");
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  CardButton = props => {
    const {
        customClassNames,
        path,
        label,
        onClick,
        buttonTestId,
        variant = "ctalinkWithArrow",
        url
      } = props,
      buttonClasses = (0, _classnames.default)({
        "BackgroundCard__button": true,
        [`${customClassNames}`]: (0, _string.isStringOfLength)(customClassNames)
      });
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: buttonClasses,
      component: _reactRouterDom.Link,
      "data-testid": buttonTestId,
      onClick: onClick,
      to: path,
      variant: variant
    }, label), (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(url) && !(0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: buttonClasses,
      component: "a",
      "data-testid": buttonTestId,
      onClick: onClick,
      href: url,
      target: "_blank",
      variant: variant
    }, label));
  };

/**
 * Card with background image and hover CSS behavior
 *
 * @visibleName Background Card
 * @author Tanner Williams
*/
const BackgroundCard = props => {
  const {
      alt = "",
      button,
      children,
      customTheme = {},
      fragmentId,
      imageHeight = "20rem",
      src = "",
      styles = {},
      testId,
      variant = "left"
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    containerSx = merge((0, _CardStyles.DefaultBackgroundCardSx)(theme, src, imageHeight, variant), styles);
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: "backgroundCard",
    "data-testid": testId,
    sx: containerSx
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "backgroundCard__image",
    title: alt
  }), /*#__PURE__*/_react.default.createElement(_CardContent.default, {
    className: "backgroundCard__content"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "backgroundCard__innerContent"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children), button.label && /*#__PURE__*/_react.default.createElement(CardButton, button))));
};

// Define propTypes;
BackgroundCard.propTypes = {
  /** Alt/Title text for image (Default Value: "") */
  alt: _propTypes.default.string,
  /** Object describing button properties */
  button: _propTypes.default.shape({
    /** Buton label */
    label: _propTypes.default.string,
    /** Button path, if internal React Route */
    path: _propTypes.default.string,
    /** External URL, applies only if there is no defined path */
    url: _propTypes.default.string,
    /** Button variant */
    variant: _propTypes.default.string
  }),
  /** Child nodes, displays after fragment */
  children: _propTypes.default.any,
  /** Theme injection object (Default Vaule: {}) */
  customTheme: _propTypes.default.object,
  /** Content Fragment ID */
  fragmentId: _propTypes.default.string,
  /** Path to background image (Default Value: "") */
  src: _propTypes.default.string,
  /** Style override object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** Card variant controlling text positioning (Default Value: "left") */
  variant: _propTypes.default.oneOf(["center", "left"]),
  /** Height of image in card (Default Value: "20rem") */
  imageHeight: _propTypes.default.string
};
CardButton.propTypes = {
  /** @ignore */
  buttonTestId: _propTypes.default.string,
  /** Custom class(es) */
  customClassNames: _propTypes.default.string,
  /** Button label */
  label: _propTypes.default.string,
  /** Button click method */
  onClick: _propTypes.default.func,
  /** Path if internal React Route */
  path: _propTypes.default.string,
  /** External URL, applys if path is not present */
  url: _propTypes.default.string,
  /** Button variant */
  variant: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = BackgroundCard;